export default __webpack_public_path__ + "static/O0019-f424e8becc6b5853b4c8cf3a6a4f57b8.png";